import React, { useEffect, useState, useRef } from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faUserEdit } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { db } from '../../firebase';
import swal from 'sweetalert';
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  deleteDoc,
  updateDoc
} from 'firebase/firestore';
import samleImage from '../../Images/place.jpg';
import profilePictureContImage from '../../Images/place.jpg'; // fallback

function ViewAllClasses() {
  const receivedId = decodeURIComponent(window.location.search);
  const roomID = receivedId.substring(1);

  const [classData, setClassData] = useState(null);
  const [students, setStudents] = useState([]);
  const [instructorName, setInstructorName] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [searchValue, setSearchValue] = useState('');
  const [results, setResults] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [instructor, setInstructor] = useState(null);

  const [showInstructorModal, setShowInstructorModal] = useState(false);
  const [instructorSearch, setInstructorSearch] = useState('');
  const [instructorResults, setInstructorResults] = useState([]);

  const searchResultsRef = useRef(null);

  // Fetch class info
  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const classDocRef = doc(db, 'allclasses', roomID);
        const classSnap = await getDoc(classDocRef);

        if (classSnap.exists()) {
          const classInfo = classSnap.data();
          setClassData(classInfo);

          const studentsQuery = query(
            collection(db, 'StudentsInClass'),
            where('classID', '==', roomID)
          );
          const querySnapshot = await getDocs(studentsQuery);
          const studentList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setStudents(studentList);

          if (classInfo.instructor && typeof classInfo.instructor === 'string') {
            const instructorRef = doc(db, 'Employees', classInfo.instructor);
            const instructorSnap = await getDoc(instructorRef);
            if (instructorSnap.exists()) {
              const instructorData = { id: instructorSnap.id, ...instructorSnap.data() };
              setInstructor(instructorData);
              setInstructorName(instructorData.employeeName || '');
            }
          }

        } else {
          console.log('No such class!');
        }
      } catch (err) {
        console.error('Error fetching class:', err);
      }
    };

    fetchClassData();
  }, [roomID]);

  // Fetch all users for search
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersSnap = await getDocs(collection(db, 'users'));
        const allUsers = usersSnap.docs.map(doc => {
          const data = doc.data();
          return {
            profilePic: data.profilePic || profilePictureContImage,
            bio: data.bio || '',
            userStatus: data.userStatus || '',
            userId: data.userId || doc.id,
            course: data.course || '',
            userEmail: data.userEmail || ''
          };
        });
        setResults(allUsers);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const handleSearchChange = event => {
    const value = event.target.value;
    setSearchValue(value);

    if (value.trim() === '') {
      setResults([]);
      return;
    }

    setResults(prev =>
      prev.filter(
        user =>
          user.bio.toLowerCase().includes(value.toLowerCase()) ||
          user.userEmail.toLowerCase().includes(value.toLowerCase()) ||
          user.course.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const onSelectStudent = userId => {
    const student = results.find(r => r.userId === userId);
    setSelectedStudent(student);
    setResults([]);
    setSearchValue(student.bio);
  };

  const handleAddStudent = async () => {
    if (!selectedStudent) return;

    try {
      await addDoc(collection(db, 'StudentsInClass'), {
        name: selectedStudent.bio,
        course: selectedStudent.course,
        cohortDate: new Date().toISOString().split('T')[0],
        studentID: selectedStudent.userId,
        studentEmail: selectedStudent.userEmail,
        classID: roomID
      });

      setStudents(prev => [
        ...prev,
        {
          name: selectedStudent.bio,
          course: selectedStudent.course,
          cohortDate: new Date().toISOString().split('T')[0]
        }
      ]);

      setSelectedStudent(null);
      setSearchValue('');
      setShowModal(false);
    } catch (error) {
      console.error('Error adding student:', error);
    }
  };

  const handleRemoveStudent = async studentId => {
    swal({
      title: 'Are you sure?',
      text: 'This will remove the student from this class.',
      icon: 'warning',
      buttons: ['Cancel', 'Yes, remove'],
      dangerMode: true
    }).then(async willDelete => {
      if (willDelete) {
        try {
          await deleteDoc(doc(db, 'StudentsInClass', studentId));
          setStudents(prev => prev.filter(s => s.id !== studentId));
          swal('Removed!', 'The student has been removed from the class.', 'success');
        } catch (error) {
          console.error('Error removing student:', error);
          swal('Error', 'Failed to remove the student.', 'error');
        }
      }
    });
  };

  // Search Employees for Instructor Switch
  const handleInstructorSearch = async e => {
    const value = e.target.value;
    setInstructorSearch(value);

    if (value.trim() === '') {
      setInstructorResults([]);
      return;
    }

    try {
      const employeesSnap = await getDocs(collection(db, 'Employees'));
      const filtered = employeesSnap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(emp => emp.employeeName.toLowerCase().includes(value.toLowerCase()));
      setInstructorResults(filtered);
    } catch (error) {
      console.error('Error searching employees:', error);
    }
  };

const handleSwitchInstructor = async instructor => {
  try {
    await updateDoc(doc(db, 'allclasses', roomID), {
      instructor: instructor.id,
      instructorEmail: instructor.employeeEmail || ''
    });
    setInstructor(instructor);
    setInstructorName(instructor.employeeName);
    setClassData(prev => ({ ...prev, instructor: instructor.id }));
    setShowInstructorModal(false);
    swal('Success', 'Instructor switched successfully.', 'success');
  } catch (error) {
    console.error('Error switching instructor:', error);
    swal('Error', 'Failed to switch instructor.', 'error');
  }
};

  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />

        <div className="clientsComp">
          <div className="viewStudentTop">
            <h4>{classData?.classDesc || 'Class Details'}</h4>
            <button className="viewBtn1" onClick={() => setShowModal(true)}>
              <FontAwesomeIcon icon={faAdd} /> Add Students
            </button>
          </div>

          <br />

          <div className="viewStudentAbout">
            <div className="viewStudentAboutLeft">
              <p>People in this class</p>
              <div className="classmatesList">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Cohort Date</th>
                      <th>Course</th>
                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.map(student => (
                      <tr key={student.id}>
                        <td>{student.name}</td>
                        <td>{student.cohortDate}</td>
                        <td>{student.course}</td>
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleRemoveStudent(student.id)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="viewStudentAboutRight">
              <div className="viewProfPic">
                <h4>Instructor</h4>
                <div className="viewProfPicCont">
                  <img src={instructor?.profilePic || samleImage} alt="Profile" />
                </div>
<h6 className="viewProfh6">{instructor?.employeeName || 'N/A'}</h6>
                <p className="viewProfCount">{students.length} students</p>
                <p className="viewProfPhone">{instructor?.employeePhone || ''}</p>

                <button
                  className="btn btn-primary btn-sm mt-2"
                  onClick={() => setShowInstructorModal(true)}
                >
                  <FontAwesomeIcon icon={faUserEdit} /> Switch Instructor
                </button>
              </div> 
            </div>
            
          </div>
        </div>

        {/* Add Student Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Add Student to Class</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Search for a student</Form.Label>
              <Form.Control
                type="text"
                placeholder="Type student name"
                value={searchValue}
                onChange={handleSearchChange}
              />
              {results.length > 0 && (
                <div className="searchResultsStud" ref={searchResultsRef}>
                  {results.map((result, index) => (
                    <div
                      key={index}
                      className="resultItem"
                      onClick={() => onSelectStudent(result.userId)}
                    >
                      <div className="resultItemDiv">
                        <img
                          src={result.profilePic}
                          alt={`${result.bio}'s profile`}
                          width={40}
                          height={40}
                        />
                      </div>
                      <div>
                        <p>{result.bio}</p>
                        <p className="statusResult">{result.userStatus}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Form.Group>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Course</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedStudent && (
                  <tr>
                    <td>{selectedStudent.bio}</td>
                    <td>{selectedStudent.userStatus}</td>
                    <td>{selectedStudent.course}</td>
                    <td>
                      <Button variant="success" size="sm" onClick={handleAddStudent}>
                        Add
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Switch Instructor Modal */}
        <Modal show={showInstructorModal} onHide={() => setShowInstructorModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Switch Instructor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Search Instructor</Form.Label>
              <Form.Control
                type="text"
                placeholder="Type instructor name"
                value={instructorSearch}
                onChange={handleInstructorSearch}
              />
            </Form.Group>

            {instructorResults.length > 0 && (
              <Table striped bordered hover className="mt-3">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {instructorResults.map(inst => (
                    <tr key={inst.id}>
                      <td>{inst.employeeName}</td>
                      <td>{inst.employeeEmail}</td>
                      <td>
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() => handleSwitchInstructor(inst)}
                        >
                          Assign
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowInstructorModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default ViewAllClasses;